import { array, boolean, coerce, create, Describe, number, string, type } from 'superstruct';

import { addPrefixToRelativeLink } from '~services/location-helpers';

const ApiItemResponse: Describe<ApiItemResponse> = type({
  id: coerce(number(), string(), id => parseInt(id, 10)),
  title: string(),
  description: string(),
  url: string(),
  creation_date: coerce(number(), string(), date => parseInt(date, 10)),
  new_content: coerce(boolean(), string(), isNewContent => isNewContent === '1'),
  sent: coerce(boolean(), string(), isSent => isSent === '1'),
});

const ApiItemsResponse: Describe<ApiItemsResponse> = type({
  items: array(ApiItemResponse),
  totalCount: number(),
});

export function createChangelogItems(data: unknown) {
  const apiItems = create(data, ApiItemsResponse);

  const items: ChangelogItem[] = (apiItems.items || []).map(item => {
    return {
      id: item.id,
      description: item.description,
      pageTitle: item.title,
      sent: item.sent,
      isNewContent: item.new_content,
      timestamp: item.creation_date * 1000, // api delivers seconds, we need milliseconds
      url: addPrefixToRelativeLink(item.url),
    };
  });

  return { items, totalCount: apiItems.totalCount };
}
